import { commonActions, editActions, notificationsListActions } from '../actionTypes';
import { TableKeys } from '../../models';
import { ITableData } from '../../components/AppTable/model';
import produce from 'immer';
import { TABLE_COLUMNS } from '../../components/NotificationsList/NotificationsTable/models';
import { DEFAULT_PAGINATION } from '../../components/AppTable/Pagination/Pagination';

const DEFAULT_TABLE_DATA: ITableData = {
    pagination: true,
    page: 1,
    limit: DEFAULT_PAGINATION,
    sorting: {
        dataKey: TABLE_COLUMNS.SCHEDULE.dataKey,
        direction: 'desc'
    },
    animateIds: new Map(),
    selectedIds: [],
    filters: {}
};

export type IDrawer = {
    mode: DrawerMode;
    smallScreenHidden?: boolean;
    data?: $TSFixMe;
};

export enum DrawerMode {
    Insights = 'Insights',
    Notification = 'Notification'
}

export interface INotificationsListState {
    activeTab: TableKeys;
    drawer: IDrawer | null;
    searchTerm?: string;
    tableStates: { [key in TableKeys]: ITableData };
    allNotificationsView?: boolean;
}

export const TABLE_STATE_DEFAULT_STATE = Object.freeze({
    [TableKeys.DRAFTS]: {
        ...DEFAULT_TABLE_DATA,
        sorting: {
            dataKey: 'updatedAt',
            direction: 'desc'
        }
    } as ITableData,
    [TableKeys.SCHEDULED]: DEFAULT_TABLE_DATA,
    [TableKeys.ACTIVE]: DEFAULT_TABLE_DATA,
    [TableKeys.SENT]: DEFAULT_TABLE_DATA,
    [TableKeys.ARCHIVED]: DEFAULT_TABLE_DATA
});

export const notificationsListInitialState: INotificationsListState = Object.freeze({
    activeTab: TableKeys.ACTIVE,
    allNotificationsView: undefined,
    drawer: {
        mode: DrawerMode.Insights,
        smallScreenHidden: true
    },
    tableStates: { ...TABLE_STATE_DEFAULT_STATE }
});

type NotificationsListActions = {
    type: notificationsListActions | editActions | commonActions;
    payload: $TSFixMe;
    error?: boolean;
};

export default function notificationsListReducer(
    state = notificationsListInitialState,
    action: NotificationsListActions
): INotificationsListState {
    switch (action.type) {
        case notificationsListActions.SET_DRAWER: {
            return {
                ...state,
                drawer: { ...state.drawer, ...action.payload }
            };
        }

        case commonActions.ENVIRONMENT_CHANGED:
        case commonActions.SYSTEM_CHANGED: {
            return {
                ...state,
                tableStates: { ...TABLE_STATE_DEFAULT_STATE }
            };
        }

        case notificationsListActions.SEARCH_NOTIFICATONS: {
            return produce(state, draft => {
                if (draft.searchTerm !== action.payload) {
                    draft.searchTerm = action.payload;
                    draft.tableStates[TableKeys.ACTIVE].page = 1;
                    draft.tableStates[TableKeys.SCHEDULED].page = 1;
                    draft.tableStates[TableKeys.SENT].page = 1;
                    draft.tableStates[TableKeys.DRAFTS].page = 1;
                    draft.tableStates[TableKeys.ARCHIVED].page = 1;
                }
            });
        }

        case notificationsListActions.SET_ACTIVE_TAB:
            return { ...state, activeTab: action.payload };

        case notificationsListActions.SET_ALL_NOTIFICATIONS_VIEW:
            return { ...state, allNotificationsView: action.payload };

        case notificationsListActions.SET_TABLE_STATE: {
            const { key, data } = action.payload;
            let page = state.tableStates[key].page;

            if (data.sorting || data.filters) {
                page = 1;
            }

            return {
                ...state,
                tableStates: {
                    ...state.tableStates,
                    [key]: {
                        ...state.tableStates[key],
                        page,
                        ...data
                    }
                }
            };
        }

        case notificationsListActions.RESET_NOTIFICATIONS_LIST_PAGE: {
            return {
                ...state,
                tableStates: state.tableStates,
                drawer: notificationsListInitialState.drawer,
                searchTerm: notificationsListInitialState.searchTerm
            };
        }
        default:
            return state;
    }
}
